import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "./GameEngines.messages";
import styles from "./GameEngines.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";

interface GameEnginess {
  title: string;
}

export const GameEngines: React.FC<GameEnginess> = () => {
  const { formatMessage } = useIntl();

  return (
    <SimpleLayoutView>
      <div className={styles.GameEngines}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G6_P2_S1_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G6_P2_S1_Description) }}></p>
              </div>,

              <div key={2} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G6_P2_S2_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G6_P2_S2_Description) }}></p>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
